"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import { trackCategoryClick } from "@/app/lib/tracking/interactions";

interface PopularCategoryCardProps {
  category: SectionItem;
}

const PopularCategoryCard: FC<PopularCategoryCardProps> = ({ category }) => {
  const categoryName = category.label || category.name || "Kategori";
  const categoryLink = category.link || category.slug || "#";
  const categoryImage = category.image;
  const categoryDescription = category.description || "";
  const backgroundColor = category.background_color || "#E8F5E9";

  return (
    <Link href={categoryLink} className="group block" onClick={() => { if (category.id) trackCategoryClick(category.id); }}>
      <div className="relative pt-12">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 z-10 transform group-hover:-translate-y-2 group-hover:scale-110 transition-all duration-300 ease-out">
          <Image
            src={categoryImage}
            alt={categoryName}
            width={90}
            height={90}
            className="object-contain"
          />
        </div>
        <div
          className="relative w-full h-35.5 rounded-lg transition-all duration-300 ease-out flex items-center justify-center pt-8 group-hover:shadow-lg group-hover:scale-105 group-hover:brightness-95"
          style={{ backgroundColor }}
        >
          <div className="flex flex-col gap-3">
            <h3 className="text-base sm:text-lg md:text-xl font-medium text-center text-gray-800 group-hover:text-main transition-colors duration-300 px-4">
              {categoryName}
            </h3>
            {categoryDescription && (
              <p className="text-sm sm:text-base md:text-lg font-medium text-center text-gray-600 group-hover:text-gray-800 transition-colors duration-300 px-4">
                {categoryDescription}
              </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PopularCategoryCard;
